export const cn = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        ip_free: '技术保护',
        ip_trial: '技术保护',
        ip_commercial_old: '技术保护',
        ip_commercial: '技术保护',
        material_trial: '新材料',
        material_commercial_old: '新材料',
        material_commercial: '新材料',
        air_free: 'Eureka 基础版',
        air_trial: '技术方案',
        air_commercial: '技术方案',
        insights_trial: 'Eureka Scout',
        insights_commercial: 'Eureka Scout',
    },
}

export const en = {
    PtUserBanner: {
        endTime: 'Expiration Date: {date}',
        ip_free: 'Eureka Search',
        ip_trial: 'Eureka Search',
        ip_commercial_old: 'Eureka Search',
        ip_commercial: 'Eureka Search',
        material_trial: 'Eureka Materials',
        material_commercial_old: 'Eureka Materials',
        material_commercial: 'Eureka Materials',
        air_free: 'Eureka Basic',
        air_trial: 'Eureka Ideas',
        air_commercial: 'Eureka Ideas',
        insights_trial: 'Eureka Scout',
        insights_commercial: 'Eureka Scout',
    },
}

export const jp = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        ip_free: '計画保護',
        ip_trial: '計画保護',
        ip_commercial_old: '計画保護',
        ip_commercial: '計画保護',
        material_trial: '材料科学',
        material_commercial_old: '材料科学',
        material_commercial: '材料科学',
        air_free: 'Eureka 基礎版',
        air_trial: '研究開発計画',
        air_commercial: '研究開発計画',
        insights_trial: 'Eureka Scout',
        insights_commercial: 'Eureka Scout',
    },
}

export const tw = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        ip_free: '科技保護',
        ip_trial: '科技保護',
        ip_commercial_old: '科技保護',
        ip_commercial: '科技保護',
        material_trial: '新材料',
        material_commercial_old: '新材料',
        material_commercial: '新材料',
        air_free: 'Eureka 基礎版',
        air_trial: '科技方案',
        air_commercial: '科技方案',
        insights_trial: 'Eureka Scout',
        insights_commercial: 'Eureka Scout',
    },
}
